import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

// Set by deploy.sh at build time; empty in local development, where the check is skipped
const CURRENT_VERSION = process.env.REACT_APP_BUILD_VERSION;
const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const SNOOZE_MS = 10 * 60 * 1000;

const NewVersionBanner = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [snoozedUntil, setSnoozedUntil] = useState(0);

  useEffect(() => {
    if (!CURRENT_VERSION) {
      return undefined;
    }

    const checkVersion = () => {
      // Bypass any cache so we always see the version that is actually deployed
      fetch(`${process.env.PUBLIC_URL}/version.json?t=${Date.now()}`, { cache: "no-store" })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          if (data && data.version && data.version !== CURRENT_VERSION) {
            setUpdateAvailable(true);
          }
        })
        .catch(() => {
          // Offline or file missing: try again on the next check
        });
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkVersion();
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, CHECK_INTERVAL_MS);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", checkVersion);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", checkVersion);
    };
  }, []);

  // Bring the prompt back once a snooze runs out
  useEffect(() => {
    if (!snoozedUntil) {
      return undefined;
    }

    const timeout = setTimeout(() => setSnoozedUntil(0), snoozedUntil - Date.now());
    return () => clearTimeout(timeout);
  }, [snoozedUntil]);

  return (
    <Modal
      show={updateAvailable && !snoozedUntil}
      centered
      backdrop="static"
      keyboard={false}
      aria-labelledby="new-version-title"
    >
      <Modal.Header>
        <Modal.Title id="new-version-title">
          <i className="mdi mdi-update"></i> New version available
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        A new version of the portal has been released. Please reload to get the latest changes.
        <br />
        <small className="text-muted">
          If you are in the middle of entering data, finish and submit it first, then reload.
        </small>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={() => setSnoozedUntil(Date.now() + SNOOZE_MS)}>
          Remind me in 10 minutes
        </Button>
        <Button variant="primary" onClick={() => window.location.reload()}>
          Reload now
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NewVersionBanner;
